import {
  marketingAttributionEvent,
  MarketingChannel,
} from "@redotech/redo-model/marketing";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const dailyMessageMetricsRowSchema = z.object({
  DATE: z.date(),
  EMAIL_SENT: z.number(),
  SMS_SENT: z.number(),
  TOTAL_SENT: z.number(),
});

const messagePerformanceTotalsSchema = z.object({
  totalMessagesSent: z.number(),
  totalEmailsSent: z.number(),
  totalSmsSent: z.number(),
  totalOpens: z.number(),
  totalClicks: z.number(),
  totalBounces: z.number(),
  totalSpam: z.number(),
  totalUnsubscribes: z.number(),
  totalOrders: z.number(),
  openRate: z.number(),
  clickRate: z.number(),
  bounceRate: z.number(),
  spamRate: z.number(),
  unsubscribeRate: z.number(),
  conversionRate: z.number(),
  previousTotalMessagesSent: z.number(),
  previousOpenRate: z.number(),
  previousClickRate: z.number(),
  previousConversionRate: z.number(),
});

export const getMessagePerformanceMetrics = {
  name: "getMessagePerformanceMetrics" as const,
  input: z.object({
    startDate: zExt.instant(),
    endDate: zExt.instant(),
    attributionDays: z.number().min(1).max(30).optional().default(5),
    channels: z.array(z.enum(MarketingChannel)).optional(),
    attributionEvents: z
      .array(z.enum(Object.values(marketingAttributionEvent)))
      .optional(),
  }),
  output: z.object({
    dailyMetrics: z.array(dailyMessageMetricsRowSchema),
    totals: messagePerformanceTotalsSchema,
  }),
};
